<template>
	<div class="container">
		<h2>Certificates</h2>
		<v-row>
			<v-col>
				<v-card class="d-flex pa-2" flat outlined>
					<span class="mx-2"><strong>Filters</strong></span>
					<v-divider vertical class="mx-2"></v-divider>
					<a
						@click="filter = ''"
						class="mx-2"
						:style="
							filter !== '' ? 'color: grey' : 'color: #86ae41'
						"
					>
						None
					</a>
					<a
						@click="filter = 'Last Week'"
						class="mx-2"
						:style="
							filter !== 'Last Week'
								? 'color: grey'
								: 'color: #86ae41'
						"
					>
						Last Week
					</a>
				</v-card>
			</v-col>
		</v-row>
		<div v-for="(certificate, key) in filteredCertificates" :key="key">
			<certificateCard :certificate="certificate.period" :reference="certificate.reference" />
		</div>
	</div>
</template>


<script>
import { mapGetters } from "vuex";
import Repository from "@/store/Services/Repository.js";
import certificateCard from "@/components/Seller Components/certificateCard.vue";

export default {
	name: "UserCertificates",
		metaInfo(){
		return{
			title: "IP-BID.com - My Certificates"
		}
	},
	components: {
		certificateCard
	},
	data() {
		return {
			loading: false,
			certificates: [],
			filter: ""
		};
	},
	created() {
		this.loading = true;
	},
	async mounted() {
		await Repository.get("seller/certificate-list", {
			headers: { Authorization: `Bearer ${this.token}` }
		}).then(response => {
			this.certificates = response.data;
		});
		this.loading = false;
	},
	computed: {
		...mapGetters(["token"]),
		filteredCertificates() {
			const daysAgo = days => {
				return new Date().getTime() - 1000 * 60 * 60 * 24 * days;
			};

			switch (this.filter) {
				case "":
					return this.certificates;
				case "Last Week":
					return this.certificates.filter(
						i =>
							Date.parse(i.period.createdDate) > daysAgo(7)
					);
				default:
					return this.certificates;
			}
		}
	}
};
</script>